var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHubspotClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ixvgqdlcca",
    d: "M13.494 2.262c.341.349.341.915 0 1.263L9.11 8.002l4.384 4.473c.341.348.341.914 0 1.263-.342.35-.896.35-1.238 0L7.875 9.263l-4.381 4.475c-.314.32-.805.347-1.148.08l-.09-.08c-.341-.349-.341-.915 0-1.263L6.64 8.002 2.256 3.525c-.341-.348-.341-.914 0-1.263.342-.35.896-.35 1.238 0l4.38 4.474 4.382-4.474c.342-.35.896-.35 1.238 0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ssm3i10p0b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ixvgqdlcca"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    xlinkHref: "#ixvgqdlcca"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#1B8C96",
    mask: "url(#ssm3i10p0b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H12V12H0z",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHubspotClose);
export default __webpack_public_path__ + "static/media/hubspot-close.31fec51dc17e158423387843ac3accf7.svg";
export { ForwardRef as ReactComponent };